module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headerpage', {
    attrs: {
      "status": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "deground"
  }, [_c('div', {
    staticClass: "indexpage"
  }, [_c('div', {
    staticClass: "box",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "top": "0"
    },
    attrs: {
      "src": _vm._f("addurl")(_vm.common.public_pic)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "box_top_img",
    attrs: {
      "src": require("../../assets/images/qie/10.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "adaptation",
    staticStyle: {
      "background-color": "#f6f8f7"
    }
  }, [_c('div', {
    staticClass: "box1"
  }, [_vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "box1_cent",
      on: {
        "click": function($event) {
          return _vm.detailjump('detail', item.id, 5)
        }
      }
    }, [_c('img', {
      staticClass: "box1_img",
      attrs: {
        "src": _vm._f("addurl")(item.image)
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "1",
        "margin": "0 20px",
        "height": "160px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "box1_cent_tt1 text-cut"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "box1_cent_tt  text-cut2"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('div', {
      staticClass: "box1_cent_tt",
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v("发布时间：" + _vm._s(item.realse_time))])]), _vm._v(" "), _c('div', {
      staticClass: "box1_cent_tt",
      staticStyle: {
        "font-size": "15px",
        "color": "#0170c1"
      }
    }, [_vm._v("阅读全文")])])
  }), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('Nomore')], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "box2 pagecss"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagesize,
      "hide-on-single-page": true,
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), (_vm.list.length !== 0) ? _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc711fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/service/servicelist.vue
// module id = 897
// module chunks = 1